import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const prepend = (source, element) => {
    async function* iterator() {
        yield element;
        yield* source;
    }
    return new BasicAsyncEnumerable(iterator);
};
